/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_Events_ErrorInputs */

const es_tools_microsoft_calendar_events_error = /** @type {(inputs: Tools_Microsoft_Calendar_Events_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener eventos de Microsoft`)
};

const en_tools_microsoft_calendar_events_error = /** @type {(inputs: Tools_Microsoft_Calendar_Events_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error fetching Microsoft events`)
};

/**
* | output |
* | --- |
* | "Error fetching Microsoft events" |
*
* @param {Tools_Microsoft_Calendar_Events_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_events_error = /** @type {((inputs?: Tools_Microsoft_Calendar_Events_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_Events_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_events_error(inputs)
	return en_tools_microsoft_calendar_events_error(inputs)
});
export { tools_microsoft_calendar_events_error as "tools.microsoft_calendar.events_error" }